module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [(_vm.chartHasNoData) ? _c('div', {
    staticClass: "chart-has-no-data"
  }, [_c('img', {
    attrs: {
      "src": "static/img/no_data.svg"
    }
  })]) : _c('div', {
    staticClass: "chart-wrapper"
  }, [_c('div', {
    staticClass: "chart-stage"
  }, [_c('highmaps', {
    ref: "highmaps",
    attrs: {
      "options": _vm.options
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c868123a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboards/car/mainCar/maptypes/regions.vue
// module id = 976
// module chunks = 0